import { useMemo, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Drawer } from 'components/Drawer/Drawer';
import { Button } from 'components/FormComponents';
import { useTableContext } from 'components/Table/Table';

import { SavedViewDrawerForm } from './SavedViewDrawerForm';
import formStyles from './SavedViewDrawerForm.module.scss';
import { validateSavedViewDrawerForm } from './savedViewDrawerFormValidation';
import { buildReportingFilterPillsFromQueryParams } from './savedViewQueryParams';

export const SaveViewDrawer = ({ open, onClose, onSave }) => {
  const { t } = useTranslation();
  const { queryParams } = useTableContext();

  const [viewName, setViewName] = useState('');
  const [errors, setErrors] = useState({});

  const filterPills = useMemo(
    () => buildReportingFilterPillsFromQueryParams(queryParams),
    [queryParams],
  );

  const validate = () => {
    const next = validateSavedViewDrawerForm(t, { viewName });
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const handleSave = async () => {
    if (!validate()) return;
    try {
      await onSave?.({ viewName, filterPills, savedQueryParams: queryParams });
      handleClose();
    } catch {
      // Save failed; keep drawer open
    }
  };

  const handleClose = () => {
    setViewName('');
    setErrors({});
    onClose();
  };

  return (
    <Drawer open={open} onClose={handleClose} title={t('reporting.saveView')}>
      <Drawer.Body>
        <SavedViewDrawerForm
          filterPills={filterPills}
          viewName={viewName}
          onViewNameChange={e => {
            setViewName(e.target.value);
            if (errors.viewName) setErrors(prev => ({ ...prev, viewName: '' }));
          }}
          viewNameError={errors.viewName}
        />
      </Drawer.Body>

      <Drawer.Footer>
        <div className={formStyles.footer}>
          <Button type="secondary" onClick={handleClose}>
            {t('common.cancel')}
          </Button>
          <Button icon="bookmark" onClick={handleSave}>
            {t('reporting.saveView')}
          </Button>
        </div>
      </Drawer.Footer>
    </Drawer>
  );
};
